import useAuth from './utils/useAuth';
import { useClientCode } from './api/useClientCode';
import { useSessionStorage } from './utils/useSessionStorage';

export interface PoweredByBranding {
  enabled: boolean;
  clientLogoUrl: string | undefined;
}

/**
 * Resolves Powered By branding from the authenticated user client when available,
 * otherwise from sessionStorage clientCode → package_details.
 */
export const usePoweredByBranding = (): PoweredByBranding => {
  const { user } = useAuth();
  const sessionClientCode = useSessionStorage('clientCode');

  const userClient = user?.caller_role?.active_subscription?.package?.client;
  const userLogoUrl =
    userClient?.powered_by_header_enabled && userClient.powered_by_header_file_url
      ? userClient.powered_by_header_file_url
      : undefined;

  const { data: packageDetails } = useClientCode({
    partnerCode: userLogoUrl ? undefined : (sessionClientCode ?? undefined),
  });

  if (userLogoUrl) {
    return {
      enabled: true,
      clientLogoUrl: userLogoUrl,
    };
  }

  const packageClient = packageDetails?.client;
  const packageLogoUrl =
    packageClient?.powered_by_header_enabled && packageClient.powered_by_header_file_url
      ? packageClient.powered_by_header_file_url
      : undefined;

  if (packageLogoUrl) {
    return {
      enabled: true,
      clientLogoUrl: packageLogoUrl,
    };
  }

  return { enabled: false, clientLogoUrl: undefined };
};
